import moment from "moment";

export const APP_NAME = "Halal Meditation"
export const getDateFormat = (date) => moment(date).local().format("DD/MM/YYYY h:mma")
// export const getDateFormat = (date) => moment.parseZone(date).local().format("DD/MM/YYYY h:mma");